module.exports = __webpack_public_path__ + "static/media/upload.45462fca.PNG";